export const allText = {
  Logout: ["Log Keluar"],
  No: ["Tidak"],
  Yes: ["Ya"],
  "View Records": ["Lihat Rekod"],
  Submit: ["Hantar"],
  Weather: ["Cuaca"],
  Profile: ["Profil"],
  "Update Profile": ["Kemaskini Profil"],
  "Update Profile Details": ["Kemaskini Butiran Profil"],
  Return: ["Kembali"],
  Update: ["Kemaskini"],
  "Delete Account": ["Padamkan Akaun"],
  "Don't have anything to update? ": ["Tiada apa-apa untuk dikemas kini? "],
  "GINA Records": ["Rekod GINA"],
  "Health Advice": ["Panduan Sihat"],
  "question 1": ["soalan 1"],
  "question 2": ["soalan 2"],
  "question 3": ["soalan 3"],
  "question 4": ["soalan 4"],
  "GINA Test": ["Ujian GINA"],
  "GINA Result": ["Hasil GINA"],
  "In the past 4 weeks, do you have:": [
    "Dalam 4 minggu yang lalu, anda mengalami:",
  ],
  "Daytime asthma symptoms more than twice per week?": [
    "Simptom asma pada waktu siang lebih daripada dua kali seminggu?",
  ],
  "Reliever needed for symptoms more than twice per week?": [
    "Pelega diperlukan untuk simptom lebih dari dua kali seminggu?",
  ],
  "Any activity limitation due to asthma?": ["Had aktiviti disebabkan asma?"],
  "Any night waking due to asthma?": ["Malam terjaga kerana asma?"],
  "Uncontrolled Asthma": ["Asma tidak terkawal"],
  "Partly Controlled Asthma": ["Asma terkawal separa"],
  "Well-Controlled Asthma": ["Asma terkawal"],
  "Date Time": ["Masa Tarikh"],
  "Asthma Status": ["Status Asma"],
  "Air Quality": ["Kualiti Udara"],
  Clouds: ["Mendung"],
  Rain: ["Hujan"],
  Clear: ["Cerah"],
  Thunderstorm: ["Ribut Petir"],
  Drizzle: ["Hujan Renyai"],
  snow: ["Salji"],
  Snow: ["Salji"],
  Mist: ["Kabus"],
  Smoke: ["Asap"],
  Haze: ["Jerebu"],
  Dust: ["Debu"],
  Fog: ["Kabus"],
  Sand: ["Pasir"],
  Ash: ["Ash"],
  Squall: ["Ribut"],
  Tornado: ["Tornado"],
  "Good (1)": ["Baik (1)"],
  "Fair (2)": ["Adil (2)"],
  "Moderate (3)": ["Sederhana (3)"],
  "Poor (4)": ["Buruk (4)"],
  "Very Poor (5)": ["Amat Buruk (5)"],
  "Current chance of asthma exacerbation": ["Peluang penyakit asma semasa"],
  "Previous chance of asthma exacerbation": [
    "Peluang penyakit asma sebelumnya",
  ],
  High: ["Tinggi"],
  Medium: ["Sederhana"],
  Low: ["Rendah"],
  "-": ["-"],
  "Health Recommendation for Asthmatic Patients: ": [
    "Cadangan Kesihatan untuk Pesakit Asma: ",
  ],
  "Take your usual dose of reliever inhaler before going out": [
    "Ambil dos biasa penyedut pelega sebelum keluar",
  ],
  "Put extra care to take your medication as prescribed": [
    "Mengambil ubat anda seperti yang ditetapkan",
  ],
  "Wear a mask to cover your nose and mouth loosely": [
    "Pakai topeng untuk menutup hidung dan mulut anda",
  ],
  "The mask can prevent airways from being shocked by cold air": [
    "Topeng boleh menghalang saluran pernafasan daripada terkena udara sejuk",
  ],
  "Keep an eye on the air quality index forecast and pollen substances in the air":
    ["Perhatikan ramalan indeks kualiti udara dan bahan debunga di udara"],
  "Do not forgot to bring along your reliever inhaler with you": [
    "Jangan lupa bawa penyedut pelega bersama anda",
  ],
  "Stay indoors and avoid going outside during a thunderstorm": [
    "Tinggal di dalam rumah dan elakkan keluar semasa ribut petir",
  ],
  "Make sure your windows and doors are closed to minimize exposure to allergens that may be carried by the storm":
    [
      "Pastikan tingkap dan pintu anda ditutup untuk mengurangkan pendedahan kepada alergen yang mungkin dibawa oleh ribut",
    ],
  "If you need to go outside, wear a light jacket or hoodie to protect yourself from moisture":
    [
      "Jika anda perlu keluar, pakai jaket atau hoodie ringan untuk melindungi diri anda daripada kelembapan",
    ],
  "Carry your inhaler with you in case the dampness triggers any symptoms": [
    "Bawa alat sedut anda bersama anda sekiranya kelembapan mencetuskan sebarang simptom",
  ],
  "Dress warmly, covering your mouth and nose with a mask to filter the air before breathing it in":
    [
      "Berpakaian hangat, tutup mulut dan hidung dengan topeng untuk menapis udara sebelum menghirupnya",
    ],
  "Avoid strenuous activities in the cold and take breaks indoors if needed": [
    "Elakkan aktiviti lasak semasa sejuk dan berehat di dalam rumah jika perlu",
  ],
  "Be cautious when going outside in misty conditions, as moisture in the air can irritate your airways":
    [
      "Berhati-hati apabila keluar dalam keadaan berkabus, kerana kelembapan di udara boleh merengsakan saluran udara anda",
    ],
  "Consider wearing a mask or using a scarf to cover your nose and mouth": [
    "Pertimbangkan untuk memakai topeng atau menggunakan skarf untuk menutup hidung dan mulut anda",
  ],
  "Stay indoors and keep your windows and doors closed to minimize exposure to smoke":
    [
      "Kekal di dalam rumah dan pastikan tingkap dan pintu anda tertutup untuk mengurangkan pendedahan kepada asap",
    ],
  "Use air purifiers or filters to improve indoor air quality": [
    "Gunakan pembersih udara atau penapis untuk meningkatkan kualiti udara dalaman",
  ],
  "Stay indoors as much as possible during hazy conditions": [
    "Kekal di dalam rumah sebanyak mungkin semasa keadaan berjerebu",
  ],
  "If you need to go outside, wear a mask to filter out some of the pollutants in the air":
    [
      "Jika anda perlu keluar, pakai topeng untuk menapis beberapa bahan pencemar di udara",
    ],
  "Carry your inhaler with you in case any symptoms triggered": [
    "Bawa alat sedut anda bersama anda sekiranya terdapat sebarang simptom",
  ],
  "Avoid areas with high dust levels, such as construction sites or dusty environments":
    [
      "Elakkan kawasan dengan paras habuk yang tinggi, seperti tapak pembinaan atau persekitaran berdebu",
    ],
  "Use a damp cloth to clean surfaces in your home and reduce dust accumulation":
    [
      "Gunakan kain lembap untuk membersihkan permukaan di rumah anda dan mengurangkan pengumpulan habuk",
    ],
  "Minimize outdoor activities during foggy conditions, as moisture in the air can trigger asthma symptoms":
    [
      "Kurangkan aktiviti luar semasa keadaan berkabus, kerana kelembapan di udara boleh mencetuskan gejala asma",
    ],
  "Protect your airways from sand particles by wearing a mask that covers your nose and mouth":
    [
      "Lindungi saluran udara anda daripada partikel pasir dengan memakai topeng yang menutup hidung dan mulut anda",
    ],
  "Seek shelter indoors during sandstorms or strong winds carrying sand particles":
    [
      "Cari perlindungan di dalam rumah semasa ribut pasir atau angin kencang yang membawa zarah pasir",
    ],
  "Stay indoors during ashfall and keep windows and doors closed to prevent ash from entering your home":
    [
      "Kekal di dalam rumah semasa hujan abu dan tutup tingkap dan pintu untuk mengelakkan abu daripada memasuki rumah anda",
    ],
  "Use air purifiers or filters to reduce the amount of ash in the air": [
    "Gunakan penulen udara atau penapis untuk mengurangkan jumlah abu di udara",
  ],
  "Take precautions, seek shelter indoors and stay away from windows": [
    "Ambil langkah berjaga-jaga, dapatkan perlindungan di dalam rumah dan jauhi tingkap",
  ],
  "If you need to go outside, wear protective clothing such as a windbreaker or jacket with a hood":
    [
      "Jika anda perlu pergi ke luar, pakai pakaian pelindung seperti windbreaker atau jaket dengan tudung",
    ],
  "Take immediate shelter in a basement, storm cellar, or interior room away from windows":
    [
      "Berlindung segera di ruang bawah tanah, ruang bawah tanah ribut, atau bilik dalaman jauh dari tingkap",
    ],
  "Make sure you have your emergency asthma medications with you in case of an asthma attack":
    [
      "Pastikan anda membawa ubat asma kecemasan anda sekiranya anda diserang asma",
    ],
};
